import * as icons from '@/components/common/icons';
import { IconSVGComponentProps } from '@/components/common/icons/IconComponent';
import { assert } from '@common/errors';
import { IconName } from '@common/react/icons';

interface IconProps extends IconSVGComponentProps {
    name: IconName;
}

const Icon = ({ name, ...props }: IconProps) => {
    const IconComponent = icons[name];

    assert(IconComponent, `Icon component not found for name: ${name}`);

    return <IconComponent {...props} />;
};

export default Icon;
